// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Dependencies_li {\n  margin-left: 2.25em;\n  padding-left: 1.5em;\n  text-indent: -1.5em;\n}\n.Dependencies_li .Tooltip {\n  padding-left: 0;\n  margin-left: -2em;\n  text-indent: 0;\n}\n", ""]);
// Exports
module.exports = exports;
